import { useContext } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { CreateStockTransfersContext, CreateStockTransfersValues } from '../contexts/CreateStockTransfersContext';

export const CreateStockTransfersInsufficientStockDialog = () => {
  const { insufficientStockWarning, continueInsufficientStockTransfer, cancelInsufficientStockTransfer, isProcessingSubmit, t } = useContext(CreateStockTransfersContext) as CreateStockTransfersValues;

  return (
    <Dialog fullWidth
      maxWidth='md'
      open={insufficientStockWarning !== null}
      onClose={cancelInsufficientStockTransfer}
      aria-labelledby='insufficient-stock-title'>
      <DialogTitle id='insufficient-stock-title'>
        {t('create_modal.insufficient_stock_title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 4 }}>
          {t('create_modal.insufficient_stock_message')}
        </DialogContentText>
        <TableContainer>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell>{t('create_modal.item_number_header')}</TableCell>
                <TableCell>{t('create_modal.item_uom_header')}</TableCell>
                <TableCell align='right'>{t('create_modal.recorded_stock')}</TableCell>
                <TableCell align='right'>{t('create_modal.item_quantity_header')}</TableCell>
                <TableCell align='right'>{t('create_modal.projected_stock')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {insufficientStockWarning?.insufficientStockItems?.map(item => (
                <TableRow key={item.itemNumber}>
                  <TableCell>{item.itemNumber}</TableCell>
                  <TableCell>{item.uom}</TableCell>
                  <TableCell align='right'>{item.quantityOnHand}</TableCell>
                  <TableCell align='right'>{item.requestedQuantity}</TableCell>
                  <TableCell align='right'>{item.projectedQuantityOnHand}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Stack direction='row'
          spacing={4}>
          <Button variant='secondary'
            size='lg'
            disabled={isProcessingSubmit}
            onClick={cancelInsufficientStockTransfer}>
            {t('create_modal.cancel_button')}
          </Button>
          <Button variant='primary'
            size='lg'
            disabled={isProcessingSubmit}
            onClick={continueInsufficientStockTransfer}>
            {t('create_modal.continue_button')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
